var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M7.5,15C3.4,15,0,11.6,0,7.5S3.4,0,7.5,0S15,3.4,15,7.5S11.6,15,7.5,15z M7.5,1C3.9,1,1,3.9,1,7.5 S3.9,14,7.5,14S14,11.1,14,7.5S11.1,1,7.5,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M7.5,10C7.2,10,7,9.8,7,9.5V8.8C7,8,7.5,7.3,8.2,7c0.6-0.3,1-1,0.9-1.7C8.9,4.7,8.4,4.2,7.8,4.1 c-0.5-0.1-1,0-1.3,0.3C6.2,4.7,6,5.1,6,5.5C6,5.8,5.8,6,5.5,6S5,5.8,5,5.5c0-0.7,0.3-1.4,0.9-1.9C6.4,3.1,7.2,2.9,8,3.1 c1,0.2,1.9,1,2,2c0.2,1.1-0.4,2.3-1.4,2.8C8.2,8.1,8,8.4,8,8.8v0.7C8,9.8,7.8,10,7.5,10z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    cx: 7.5,
    cy: 11.5,
    r: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c715c63a91d4fbbd63e885a0f8b16444.svg";
export { ForwardRef as ReactComponent };